import { Component, OnInit, Injector, OnDestroy, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

// tslint:disable-next-line: max-line-length
import { BitfPSortApiRequestPart } from '@bitf/core/api-call-state/bitf-p-api-call-state/bitf-p-sort-api-request-part.builder';
import { BitfApiRequestPart } from '@common/libs/bitforce/core/api-call-state/bitf-api-request-part';

import { LoaderService, FsService, StoreService, ApiCallStateService, DialogsService } from '@services';
import { EApiCallStateNames, EApiRequestPartKeys, EBitfApiSortDirection } from '@enums';
import { FsStore } from '@models';

@Component({
  selector: 'prada-fs-create-item',
  templateUrl: './fs-create-item.component.html',
  styleUrls: ['./fs-create-item.component.scss'],
})
export class FsCreateItemComponent implements OnInit, OnDestroy {
  @Input() fsStore: FsStore;

  subscription: Subscription = new Subscription();

  apiCallStateName = EApiCallStateNames.DOCUMENT_ARCHIVE_LIST;
  paginationRequestPart: BitfApiRequestPart;
  nameRequestPart: BitfApiRequestPart;
  contentTypeRequestPart: BitfApiRequestPart;
  createdByRequestPart: BitfApiRequestPart;
  modifiedByRequestPart: BitfApiRequestPart;
  createdRequestPart: BitfApiRequestPart;
  modifiedRequestPart: BitfApiRequestPart;

  isFullTextSearch = false;
  loaderService: LoaderService;
  fsService: FsService;
  translateService: TranslateService;
  storeService: StoreService;
  apiCallStateService: ApiCallStateService;
  dialogService: DialogsService;

  constructor(public injector: Injector) {
    this.loaderService = this.injector.get<LoaderService>(LoaderService);
    this.fsService = this.injector.get<FsService>(FsService);
    this.translateService = this.injector.get<TranslateService>(TranslateService);
    this.storeService = this.injector.get<StoreService>(StoreService);
    this.apiCallStateService = this.injector.get<ApiCallStateService>(ApiCallStateService);
    this.dialogService = this.injector.get<DialogsService>(DialogsService);
  }

  ngOnInit() {
    this.apiCallStateName = this.fsStore.configuration.apiCallStateName;

    // NOTE this is used to disable the create button if the user is in full text search which is no a real folder
    this.subscription = this.apiCallStateService.getStateStore$(this.apiCallStateName).subscribe(() => {
      const apiCallStateRequest = this.apiCallStateService.getApiRequest(this.apiCallStateName);
      this.isFullTextSearch = apiCallStateRequest.search.fullText
        ? apiCallStateRequest.search.fullText !== ''
        : false;
    });

    this.initRequestParts();
  }

  setCreatedSortDesc() {
    this.paginationRequestPart.reset();
    // (this.contentTypeRequestPart as BitfPSortApiRequestPart).setUndefinedDirection();
    (this.nameRequestPart as BitfPSortApiRequestPart).setUndefinedDirection();
    (this.createdByRequestPart as BitfPSortApiRequestPart).setUndefinedDirection();
    (this.modifiedByRequestPart as BitfPSortApiRequestPart).setUndefinedDirection();
    (this.modifiedRequestPart as BitfPSortApiRequestPart).setUndefinedDirection();
    this.createdRequestPart.data = {
      property: 'created',
      direction: EBitfApiSortDirection.DESC,
    };
  }

  private initRequestParts() {
    this.paginationRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.PAGINATION
    );

    // this.contentTypeRequestPart = this.apiCallStateService.getRequestPart(
    //   this.apiCallStateName,
    //   EApiRequestPartKeys.SORT_FS_ITEM_CONTENT_TYPE
    // );

    this.nameRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.SORT_FS_ITEM_NAME
    );

    this.createdByRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.SORT_FS_ITEM_CREATED_BY
    );

    this.modifiedByRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED_BY
    );

    this.createdRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.SORT_FS_ITEM_CREATED
    );

    this.modifiedRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
